import { render } from "./FabBtn.vue?vue&type=template&id=324935e6&scoped=true"
import script from "./FabBtn.vue?vue&type=script&lang=js"
export * from "./FabBtn.vue?vue&type=script&lang=js"

import "./FabBtn.vue?vue&type=style&index=0&id=324935e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-324935e6"

export default script